import React from "react";
import axios from "axios";
import { useReducer } from "react";
import { reducer } from "../reducer/index";
import { initialState } from "../reducer/index";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const handleTextChanges = (e) => {
    dispatch({
      type: "HANDLE_INPUT_TEXT",
      field: e.target.name,
      payload: e.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const myForm = event.target;
    const formData = new FormData(myForm);

    try {
      await axios.post("/", formData);
      dispatch({ type: "CLEAR_FORM" });
      toast.success("Your message has been submitted", {
        position: "top-center",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (error) {
      toast.error("An error is happening. Please try again later.", {
        position: "top-center",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  return (
    <section
      id="contact"
      name="contactForm"
      className="w-full text-gray-300 md:h-screen bg-[#0f172a] flex justify-center items-center p-4"
    >
      <ToastContainer />
      <form
        onSubmit={handleSubmit}
        name="contact"
        method="POST"
        data-netlify="true"
        className="flex flex-col max-w-[600px] w-full"
      >
        <div className="pb-8">
          <p className="inline text-4xl font-bold text-gray-300 border-b-4 border-violet-600">
            Contact
          </p>
          <p className="py-4 text-gray-300">
            //Submit the form below or shoot me an email -
            ahmaddin1000@gmail.com
          </p>
        </div>
        <input type="hidden" name="form-name" value="contact" />
        <input
          className="bg-[#ccd6f6] p-2 text-black"
          type="text"
          placeholder="Name"
          name="name"
          onChange={handleTextChanges}
          value={state.name}
        />
        <input
          type="email"
          className="my-4 p-2 bg-[#ccd6f6] text-black"
          placeholder="Email"
          name="email"
          onChange={handleTextChanges}
          value={state.email}
        />
        <textarea
          className="bg-[#ccd6f6] p-2 text-black"
          name="message"
          rows="10"
          placeholder="Message"
          onChange={handleTextChanges}
          value={state.message}
        ></textarea>
        <button
          type="submit"
          className="flex items-center px-4 py-3 mx-auto my-8 text-white border-2 hover:bg-violet-600 hover:border-violet-600"
        >
          Let's Collaborate
        </button>
      </form>
    </section>
  );
};

export default Contact;
